import { appConfig } from '../config/app';
import { IAlert, IApiList, IAvatarUrlResponse, IDeleteUserPayload, IOrganizationConnection, IPaymentSetCalculations, IPayout, IPayoutStats, IUpdateUserPayload, IUser, IUserInvites } from '../types';
import { ApiClient, IApiQueryOptions } from './ApiClient';

export const Users = {
  show: () => ApiClient.get<IUser>(`${appConfig.API_BASE_URL}/v1/me`),
  update: (body: IUpdateUserPayload) => ApiClient.put<IUser>(`${appConfig.API_BASE_URL}/v1/me`, body),
  delete: (body: IDeleteUserPayload) => ApiClient.delete<IUser>(`${appConfig.API_BASE_URL}/v1/me`, body),
  createAvatarUrl: () => ApiClient.post<IAvatarUrlResponse>(`${appConfig.API_BASE_URL}/v1/me/avatar`, {}, false),
  listAlerts: (options?: IApiQueryOptions) => ApiClient.get<IApiList<IAlert>>(`${appConfig.API_BASE_URL}/v1/me/alerts`, options),
  listInvites: () => ApiClient.get<IUserInvites>(`${appConfig.API_BASE_URL}/v1/me/invites`),

  // Payouts
  listPayouts: (options?: IApiQueryOptions) => ApiClient.get<IApiList<IPayout>>(`${appConfig.API_BASE_URL}/v1/me/payouts`, options),
  showPayoutTipCalculations: (payoutId: string) => ApiClient.get<IPaymentSetCalculations>(`${appConfig.API_BASE_URL}/v1/me/payouts/${payoutId}/calculations`),
  listPayoutsStats: (options?: IApiQueryOptions) => ApiClient.get<IPayoutStats>(`${appConfig.API_BASE_URL}/v1/me/payouts/stats`, options),
  showOrganizationsConnections: (options?: IApiQueryOptions) => ApiClient.get<IApiList<IOrganizationConnection>>(`${appConfig.API_BASE_URL}/v1/me/connections`, options),
};
